import {
  Circle,
  Calendar,
  Play,
  CheckCircle2,
  Lock,
} from "lucide-react";

const STATUS_CONFIG: Record<
  string,
  {
    label: string;
    icon: React.ComponentType<{ className?: string }>;
    color: string;
    bg: string;
  }
> = {
  created: {
    label: "Created",
    icon: Circle,
    color: "#6b7280",
    bg: "#f3f4f6",
  },
  scheduled: {
    label: "Scheduled",
    icon: Calendar,
    color: "#2563eb",
    bg: "#dbeafe",
  },
  in_progress: {
    label: "In Progress",
    icon: Play,
    color: "#d97706",
    bg: "#fef3c7",
  },
  completed: {
    label: "Completed",
    icon: CheckCircle2,
    color: "#16a34a",
    bg: "#dcfce7",
  },
  closed: {
    label: "Closed",
    icon: Lock,
    color: "#6b7280",
    bg: "#e5e7eb",
  },
};

interface JobStatusBadgeProps {
  status: string;
}

export function JobStatusBadge({ status }: JobStatusBadgeProps) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.created;
  const Icon = config.icon;

  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium"
      style={{ color: config.color, backgroundColor: config.bg }}
    >
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  );
}
